<div class="fcp-load-more-container">
    <div class="fcp-load-more-label">{{ loadMoreLabel }}</div>
    <fcp-progress-bar [progress]="progress"></fcp-progress-bar>
    <button fcp-button (click)="loadMore.emit()" [disabled]="disabled">
        {{ loadMoreButtonLabel }}
    </button>
</div>
